import React, { useRef, useEffect, useState } from 'react';
import { Text } from '@mantine/core';
import * as oauth from '../oauth.js';

const CLIENT_ID = "8896805571";

const TelegramLoginButton = ({ isRussian }) => {
  const containerRef = useRef(null);
  // null = still loading, false = loaded ok, true = failed (network blocked
  // or timed out). We only flip to true if the script definitively errors
  // or hasn't shown up in 5s — that's enough to render a friendly note
  // without blocking anything else on the page.
  const [scriptFailed, setScriptFailed] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;

    const callbackName = "__tg_oauth_cb_" + Date.now();
    window[callbackName] = (data) => {
      if (data) {
        oauth.TelegramLoginWidgetAuth({
          tgData: data,
          onJWTObtained: () => {
            window.location.href = '/';
          }
        }).catch((err) => {
          console.error('TG OAuth auth failed:', err);
        });
      }
      delete window[callbackName];
    };

    containerRef.current.innerHTML = '';

    const btn = document.createElement('button');
    btn.className = 'tg-auth-button';
    btn.setAttribute('data-style', 'filled');
    btn.textContent = 'Sign In with Telegram';
    containerRef.current.appendChild(btn);

    const script = document.createElement('script');
    script.src = 'https://oauth.telegram.org/js/telegram-login.js?5';
    script.setAttribute('data-client-id', CLIENT_ID);
    script.setAttribute('data-onauth', callbackName + '(data)');
    script.setAttribute('data-request-access', 'write');
    script.async = true;
    script.onerror = () => setScriptFailed(true);
    script.onload = () => setScriptFailed(false);
    containerRef.current.appendChild(script);

    // Russian ISPs block oauth.telegram.org and can stall the request
    // indefinitely without firing onerror. Treat 5s with no onload as a
    // failure so the UI gets a fallback.
    const timeoutID = window.setTimeout(() => {
      if (!script.dataset.loaded) setScriptFailed(true);
    }, 5000);
    script.addEventListener('load', () => {
      script.dataset.loaded = '1';
      window.clearTimeout(timeoutID);
    });

    return () => {
      window.clearTimeout(timeoutID);
      delete window[callbackName];
    };
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div ref={containerRef} style={{ colorScheme: 'light', display: 'flex', justifyContent: 'center' }} />
      {scriptFailed ? (
        <Text size="sm" c="dimmed" ta="center" mt={0}>
          {isRussian
            ? "Возможно, Telegram недоступен в вашем регионе."
            : "Telegram may not be available in your region."}
        </Text>
      ) : (
        <Text size="sm" c="dimmed" ta="center" mt={0}>
          {isRussian
            ? "После подтверждения в Telegram вернитесь на эту вкладку"
            : "After confirming in Telegram, return to this tab"}
        </Text>
      )}
    </div>
  );
};

export default TelegramLoginButton;
